
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dmca-protection-badge",
      function () {
        return require("private-next-pages/dmca-protection-badge.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dmca-protection-badge"])
      });
    }
  